<template lang="html">
  <div :class="getPositionClass()">
    <div class="border">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    position: {
      required: false,
      default: 'bottom-right'
    }
  },
  methods: {
    getPositionClass () {
      return {
        'container': true,
        [this.position]: true
      }
    }
  }
}
</script>

<style lang="css" scoped>
  .container {
    position: fixed;
    margin: .5rem;
  }
  .border {
    background: rgb(245,244,196);
    padding: 0.5rem;
  }
  .bottom-right {
    bottom: 0;
    right: 0;
  }
  .bottom-left {
    bottom: 0;
    left: 0;
  }
  .top-right {
    top: 0;
    right: 0;
  }
  .top-left {
    top: 0;
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// index.vue?f0616c68